//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LenderPoolOpenings from './LenderPoolOpenings'
import LenderPortfolioSummary from './LenderPortfolioSummary'
import { useAppKitAccount } from '@reown/appkit/react'
import { useOtChainState } from '@react/redux/store'
import { useNavigate } from 'react-router-dom'
import { fetchCompanyProfileExists } from '@react/fetchers/companyProfileFetchers'
import { logOT } from '@shared/loggingShared'

export default function LenderHome(): React.ReactElement {
  const {
    stageConfiguration: { serverApiBaseUrl, restAPIKey },
    userConnection: { accountAddr, companyProfile },
  } = useOtChainState()
  const { embeddedWalletInfo } = useAppKitAccount({ namespace: 'eip155' })
  const [existenceChecked, setExistenceChecked] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    if (embeddedWalletInfo && accountAddr && !existenceChecked) {
      fetchCompanyProfileExists(serverApiBaseUrl, restAPIKey, accountAddr).then((exists) => {
        setExistenceChecked(true)
        logOT.info('companyProfileExists', { exists })
        if (!exists) {
          navigate('/companyProfile')
        }
      })
    }
  }, [companyProfile, embeddedWalletInfo, accountAddr, existenceChecked])

  return (
    <Grid container spacing={0} justifyContent="flex-start" direction={'column'} style={{ maxWidth: '100%' }}>
      <Grid item key="LS1 " style={{ maxWidth: '100%' }}>
        <LenderPortfolioSummary />
      </Grid>
      <Grid key="openings" item style={{ maxWidth: '100%' }} sx={{ marginTop: 4, marginBottom: 4 }}>
        <Box
          sx={{
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <LenderPoolOpenings limit={4} />
        </Box>
      </Grid>
    </Grid>
  )
}
